import React, { useEffect, useMemo, useState } from "react";
import { Modal, Button, Input, Row, Col, Divider, Table } from "antd";
import { FaRegEdit } from "react-icons/fa";
import axios from "axios";

export default function ModalPrecintos({
  open,
  onClose,
  contexto, // {id_piloto,id_categoria,id_carrera,pilotoNombre}
  onGuardado, // refrescar tabla si querés
  manejarAlertas,
}) {
  const [loading, setLoading] = useState(false);
  const [vigente, setVigente] = useState(null);
  const [numero, setNumero] = useState("");

  const headers = useMemo(() => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }), []);

  useEffect(() => {
    if (!open || !contexto) return;
    cargar();
    setNumero("");
    // eslint-disable-next-line
  }, [open, contexto?.id_piloto, contexto?.id_categoria, contexto?.id_carrera]);

  const cargar = async () => {
    try {
      setLoading(true);
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/precinto/tabla-carrera`,
        { ...headers, params: contexto }
      );
      setVigente(resp.data?.tabla?.[0] || null);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const guardar = async () => {
    if (!numero) return;
    try {
      setLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/precinto/guardar`,
        {
          id_piloto: contexto.id_piloto,
          id_categoria: contexto.id_categoria,
          id_carrera: contexto.id_carrera,
          tipo: "MOTOR",
          numero,
        },
        headers
      );

      if (response.status === 200) {
        manejarAlertas?.("success", "Precinto guardado correctamente.");
        setNumero("");
        await cargar();
        onGuardado?.();
      }
    } catch (e) {
      const msg = e?.response?.data?.message || "Error al guardar el precinto";
      manejarAlertas?.("error", msg);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const editarFila = (record) => {
    setNumero(record.numero || "");
  };

  const columns = [
    { title: "NÚMERO", dataIndex: "numero", key: "numero" },
    {
      title: "ORIGEN",
      key: "origen",
      render: (_, record) =>
        record.esDeEstaCarrera ? "Esta carrera" : "Heredado de carrera anterior",
    },
    {
      title: "ACCIONES",
      key: "acciones",
      align: "center",
      render: (_, record) => (
        <FaRegEdit
          onClick={() => editarFila(record)}
          className="iconos-tablas"
          style={{ color: "blue", cursor: "pointer" }}
        />
      ),
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={`Precintos - ${contexto?.pilotoNombre || ""}`}
      footer={null}
      destroyOnClose
    >
      <Divider style={{ margin: "10px 0" }} />

      <Row gutter={8}>
        <Col span={24}>
          <Input
            value={numero}
            placeholder="Número de precinto de motor"
            onChange={(e) => setNumero(e.target.value)}
            style={{ height: 32 }}
          />
        </Col>
      </Row>

      <Row gutter={16} justify="end" style={{ marginTop: 10 }}>
        <Col xs={24} sm={12}>
          <Button
            style={{
              width: "100%",
              backgroundColor: "#233463",
              color: "#FFF",
              fontSize: 18,
              cursor: "pointer",
            }}
            onClick={onClose}
            loading={loading}
          >
            Cancelar
          </Button>
        </Col>
        <Col xs={24} sm={12}>
          <Button
            type="primary"
            onClick={guardar}
            loading={loading}
            style={{
              width: "100%",
              backgroundColor: "#BA1721",
              color: "#FFF",
              fontSize: 18,
              cursor: "pointer",
            }}
          >
            Guardar
          </Button>
        </Col>
      </Row>

      <Divider style={{ margin: "10px 0" }} />

      <Table
        dataSource={vigente ? [vigente] : []}
        columns={columns}
        rowKey="numero"
        pagination={false}
        size="small"
        loading={loading}
      />
    </Modal>
  );
}
